// extracted by mini-css-extract-plugin
export default {"linkStyleCopy":"L6-z"};